<script lang="ts">

	let isDisplayUpButton: boolean = false;
	let isFirstDisplay: boolean = true;

    /**
     * Détection du sens du scroll
     * Si vers le haut alors afficher le sous-menu
     * Si vers le vas alors masquer le sous-menu
     */
     function displayUpButton() {
        if (window.scrollY > 400) {
			isDisplayUpButton = true;
			isFirstDisplay = false;
        } else {
			isDisplayUpButton = false;        
		}
    }

</script>

<svelte:window on:scroll={displayUpButton} />
<div class="up" class:up__display={isDisplayUpButton} class:up__first={isFirstDisplay}
	on:click={() => window.scrollTo({top: 0, behavior: 'smooth'})} on:keydown={() => window.scrollTo({top: 0, behavior: 'smooth'})}>&#9650;
</div>

<style lang="scss">

	.up {
		position: fixed;
		right: 30px;
		bottom: 30px;
		z-index: 10;
		background-color: $color_orange;
		width: 35px;
		height: 30px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: $color_white;
		font-weight: bold;
		font-size: 20px;
		border: 1px solid $color_white;
		border-color: $color_primary_25;
		border-radius: 4px;
		cursor: default;
		opacity: 0;
		animation: upHid 1s;
		padding: 0 0 5px 0;
		&__display {
			opacity: 0.9;
			animation: upDis 2s;
		}
		&__first {
			display: none;
		}
	}

	@include large {
		.up {
			&__display {
				cursor: pointer;
				&:hover {
					opacity: 1;
				}
			}
		}

	}

	@keyframes upDis {
		from {
			opacity: 0;
		}
		to {
			opacity: 0.9;
		}
	}

	@keyframes upHid {
		from {
			opacity: 0.9;
		}
		to {
			opacity: 0;
		}
	}

</style>